module.exports = __webpack_public_path__ + "static/media/Alentejo.9eb2c090.svg";